import { DotLottieReact } from "@lottiefiles/dotlottie-react";

import React from "react";
import ReactDOM from "react-dom";
import { useTranslation } from "react-i18next";

import Animation from "@/assets/lottie/animation-loading.lottie";

const Loading = ({ title }) => {
  const { t } = useTranslation();
  const loadingTitle = title
    ? title
    : t("extendedWarranty.add.loadingTitle", "Yükleniyor...");

  return ReactDOM.createPortal(
    <div
      className="fixed inset-0 z-[51] flex min-h-screen w-full flex-col items-center justify-center bg-gradient-to-b from-[#0037AD] to-[#6692F0]"
      role="alert"
      aria-live="assertive"
    >
      <h1 className="text-2xl font-bold text-white">{loadingTitle}</h1>
      <DotLottieReact
        className="md:w-1/2"
        src={Animation}
        loop
        autoplay
        aria-label={t(
          "extendedWarranty.add.loadingAnimation",
          "Yükleme animasyonu",
        )}
      />
    </div>,
    document.body, // Bileşeni DOM'un body kısmına yerleştiriyoruz
  );
};

export default Loading;
